// @ts-nocheck
import {useListView} from './core/ListViewProvider'
import {UsersListHeader} from './components/header/UsersListHeader'
import {UsersTable} from './table/UsersTable'
import {KTCard} from '../../../../_metronic/helpers'
import {useState} from 'react'

const UsersList = () => {
  const [userSearch, setUserSearch] = useState('')
  const [genderFilter, setGenderFilter] = useState('')
  const [sDate, setSDate] = useState<any>('')
  const [eDate, setEDate] = useState<any>('')
  const [page, setPage] = useState(1)

  return (
    <>
      <KTCard>
        {/* Search | Filter | Export Button Begins */}
        <UsersListHeader
          genderFilter={genderFilter}
          setGenderFilter={setGenderFilter}
          userSearch={userSearch}
          setUserSearch={setUserSearch}
          sDate={sDate}
          setSDate={setSDate}
          eDate={eDate}
          setEDate={setEDate}
          page={page}
          setPage={setPage}
        />
        {/* Search | Filter | Export Button Ends */}
        <UsersTable
          genderFilter={genderFilter}
          setGenderFilter={setGenderFilter}
          userSearch={userSearch}
          setUserSearch={setUserSearch}
          sDate={sDate}
          setSDate={setSDate}
          eDate={eDate}
          setEDate={setEDate}
          page={page}
          setPage={setPage}
        />
      </KTCard>
    </>
  )
}

const UsersListWrapper = () => <UsersList />

export {UsersListWrapper}
